import { Box, Stack } from '@mui/material';
import React, { useEffect } from 'react';

function SoundWave({ className }) {
    useEffect(() => {
        const bars = document.querySelectorAll('.bar');

        bars.forEach((bar) => {
            // Random move
            bar.style.animationDuration = `${Math.random() * (0.7 - 0.2) + 0.2}s`;
        });
    }, []); // Empty dependency array to run the effect only once on component mount

    return (
        <Stack className={`sound-wave ${className}`} flexDirection="row" alignItems="center">
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
            <Box className="bar"></Box>
        </Stack>
    );
}

export default SoundWave;
